import React from 'react';

import {Select} from '@famly/mf_input_select';
import {FormControl} from '@famly/mf_input_form-control';
import {needsTranslations} from 'web-app/util/scoped-needs-translation';

import type * as Types from '../types';

type Props = {
    onChange: Types.HandlePricingGroupChange;
    value: string | null;
    options: Array<Types.PricingGroupOption>;
    isDisabled?: boolean;
};

const PricingGroupSelect = ({onChange, options, value, isDisabled}: Props) => {
    return (
        <FormControl fullWidth label={needsTranslations('SimplifiedUsBilling', 'Pricing group')}>
            <Select
                value={value}
                options={options}
                data-e2e-id={`pricing-group-select`}
                onChange={selectedOption => onChange(selectedOption, options)}
                disabled={isDisabled}
            />
        </FormControl>
    );
};

export default PricingGroupSelect;
